const {component: withoutCss} = require('./AddToCartAppConfigNoCss');

module.exports = {
  default: {
    component: withoutCss,
  },
};
